module.exports = __webpack_public_path__ + "aefb6c1b55c1039f7afb9b4f85f541a4.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/home/components/images/dialogue.png
 ** module id = 1564
 ** module chunks = 0
 **/